module.exports = __webpack_public_path__ + "img/greenvert.716891f3.png";